import { render, staticRenderFns } from "./NotFound.vue?vue&type=template&id=38d2c1fa&scoped=true&"
import script from "./NotFound.vue?vue&type=script&lang=js&"
export * from "./NotFound.vue?vue&type=script&lang=js&"
import style0 from "./NotFound.vue?vue&type=style&index=0&id=38d2c1fa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../registration-vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38d2c1fa",
  null
  
)

export default component.exports